import { useEffect, useState } from "react";

/**
 * Creates and manages a blob URL with automatic cleanup
 * Perfect for authenticated image requests that can't use direct URLs
 */
const useBlobUrl = (blob: Blob | null): string | null => {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (blob) {
      const objectUrl = URL.createObjectURL(blob);
      setUrl(objectUrl);

      return () => {
        URL.revokeObjectURL(objectUrl);
      };
    } else {
      setUrl(null);
    }
  }, [blob]);

  return url;
};

export default useBlobUrl;
